
        
    const runtime = require("../../../../../../../../node_modules/simple-nunjucks-loader/lib/cjs/runtime.js");
    
    const __nunjucks_module_dependencies__ = {};
    
        
        const __nunjucks_template_import__dep_0 = require("../../../../lib/uniform/views/templates/uniform-macros.html");
        
    __nunjucks_module_dependencies__.templates = {...__nunjucks_template_import__dep_0.__nunjucks_module_dependencies__.templates};
    __nunjucks_module_dependencies__.globals = {...__nunjucks_template_import__dep_0.__nunjucks_module_dependencies__.globals};
    __nunjucks_module_dependencies__.extensions = {...__nunjucks_template_import__dep_0.__nunjucks_module_dependencies__.extensions};
    __nunjucks_module_dependencies__.filters = {...__nunjucks_template_import__dep_0.__nunjucks_module_dependencies__.filters};
    __nunjucks_module_dependencies__.assets = {...__nunjucks_template_import__dep_0.__nunjucks_module_dependencies__.assets};
    
    
    
    
    
            const __nunjucks_template_import__filter_t = require("../../../../nunjucks/t.js");
            __nunjucks_module_dependencies__.filters['t'] = {
                module: __nunjucks_template_import__filter_t && __nunjucks_template_import__filter_t.default || __nunjucks_template_import__filter_t,
                async: false
            };
            const __nunjucks_template_import__filter_date = require("../../../../nunjucks/date.js");
            __nunjucks_module_dependencies__.filters['date'] = {
                module: __nunjucks_template_import__filter_date && __nunjucks_template_import__filter_date.default || __nunjucks_template_import__filter_date,
                async: false
            };
    
        
            __nunjucks_module_dependencies__.templates["assessments/show/views/templates/question-response-multiple-choice.html"] = (function() {
                function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("lib/uniform/views/templates/uniform-macros.html", false, "assessments/show/views/templates/question-response-multiple-choice.html", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("form", t_1);
output += "\n<ul class=\"multiple-choice-options\">\n  ";
frame = frame.push();
var t_6 = runtime.contextOrFrameLookup(context, frame, "options");
if(t_6) {var t_5 = t_6.length;
for(var t_4=0; t_4 < t_6.length; t_4++) {
var t_7 = t_6[t_4];
frame.set("op", t_7);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
output += "\n  <li\n    data-id=\"";
output += runtime.suppressValue(runtime.memberLookup((t_7),"id"), env.opts.autoescape);
output += "\"\n    class=\"mc-option ";
output += runtime.suppressValue(runtime.memberLookup((t_7),"selected_status"), env.opts.autoescape);
if(runtime.memberLookup((t_7),"is_selected")) {
output += " selected";
;
}
output += "\"\n  >\n    <label class=\"radio\" for=\"";
output += runtime.suppressValue(runtime.memberLookup((t_7),"id"), env.opts.autoescape);
output += "-option\">\n      ";
if(runtime.memberLookup((t_7),"selected_status")) {
output += "\n      <div\n        class=\"feedback feedback-";
output += runtime.suppressValue(runtime.memberLookup((t_7),"selected_status"), env.opts.autoescape);
output += "\"\n        style=\"display: none\"\n      >\n        <i class=\"pwai-status\"></i>\n      </div>\n      ";
;
}
output += "\n      <input\n        id=\"";
output += runtime.suppressValue(runtime.memberLookup((t_7),"id"), env.opts.autoescape);
output += "-option\"\n        type=\"radio\"\n        rv-checked=\"model:selected_option\"\n        tabindex=\"";
output += runtime.suppressValue(runtime.memberLookup((t_7),"order"), env.opts.autoescape);
output += "\"\n        name=\"selected_options\"\n        class=\"option ";
if(runtime.contextOrFrameLookup(context, frame, "disabled")) {
output += " disabled";
;
}
output += "\"\n        value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_7),"id"), env.opts.autoescape);
output += "\"\n        ";
if(runtime.contextOrFrameLookup(context, frame, "disabled")) {
output += "disabled=\"true\"\n        ";
;
}
output += "\n      />\n      <span>";
output += runtime.suppressValue(runtime.memberLookup((t_7),"text"), env.opts.autoescape);
output += "</span>\n    </label>\n  </li>\n  ";
;
}
}
frame = frame.pop();
output += "\n</ul>\n\n";
output += runtime.suppressValue((lineno = 38, colno = 19, runtime.callWrap(runtime.memberLookup((t_1),"flash_message"), "form[\"flash_message\"]", context, [])), env.opts.autoescape);
output += "\n\n<footer>\n  ";
if(!runtime.contextOrFrameLookup(context, frame, "is_answered")) {
output += " ";
output += runtime.suppressValue((lineno = 41, colno = 35, runtime.callWrap(runtime.memberLookup((t_1),"submit"), "form[\"submit\"]", context, [env.getFilter("t").call(context, "Submit\n  Answer","assessments.question_card.paragraph.submit_answer"),"submit"])), env.opts.autoescape);
output += "\n  ";
;
}
else {
output += "\n  <div class=\"answer-status\">\n    ";
output += runtime.suppressValue(env.getFilter("t").call(context, "Answered","assessments.question_card.paragraph.answered"), env.opts.autoescape);
output += "\n    <time is=\"relative-time\" datetime=\"";
output += runtime.suppressValue(env.getFilter("date").call(context, runtime.contextOrFrameLookup(context, frame, "modified"),""), env.opts.autoescape);
output += "\"\n      >";
output += runtime.suppressValue(env.getFilter("date").call(context, runtime.contextOrFrameLookup(context, frame, "modified"),"MMM D, YYYY h:mm A"), env.opts.autoescape);
output += "</time\n    >\n    ";
if(runtime.contextOrFrameLookup(context, frame, "is_practice") || !runtime.contextOrFrameLookup(context, frame, "is_content_completed")) {
output += "\n    <!--     <div class=\"reset-assessment-response\">\n      <a class=\"brand-color\" href=\"javascript:void(0)\">\n        <i class=\"pwai-undo-o\"></i>\n        <span>Update answer</span>\n      </a>\n    </div> -->\n    ";
;
}
output += "\n  </div>\n  ";
;
}
output += "\n</footer>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

            })();
        

        function nunjucksTemplate(ctx = {}) {
            const templateContext = {
                __nunjucks_loader_assets__: __nunjucks_module_dependencies__.assets,
                ...ctx
            };

            var nunjucks = (runtime && runtime.default || runtime)(
                {"dev":false,"jinjaCompat":false,"isAsyncTemplate":false},
                __nunjucks_module_dependencies__
            );

            if (nunjucks.isAsync()) {
                return nunjucks.renderAsync(
                    "assessments/show/views/templates/question-response-multiple-choice.html",
                    templateContext
                );
            }
        
            return nunjucks.render(
                "assessments/show/views/templates/question-response-multiple-choice.html",
                templateContext
            );
        };

        nunjucksTemplate.__nunjucks_precompiled_template__ = __nunjucks_module_dependencies__.templates["assessments/show/views/templates/question-response-multiple-choice.html"];
        nunjucksTemplate.__nunjucks_module_dependencies__ = __nunjucks_module_dependencies__;

        exports = module.exports = nunjucksTemplate;
    